import { css } from 'lit';

// Set to false to disable Christmas theme
export const CHRISTMAS_THEME_ENABLED = false;

export const christmasStyles = css`
  @keyframes snowfall {
    0% {
      transform: translateY(0) translateX(0);
      opacity: 0;
    }
    10% {
      opacity: 1;
    }
    90% {
      opacity: 1;
    }
    100% {
      transform: translateY(100vh) translateX(100px);
      opacity: 0;
    }
  }

  @keyframes snowfall-drift {
    0%,
    100% {
      transform: translateX(0);
    }
    50% {
      transform: translateX(20px);
    }
  }

  .snowflake {
    position: fixed;
    color: rgb(240, 248, 255);
    font-size: 1.5em;
    font-family: Arial, sans-serif;
    text-shadow: 0 0 8px rgba(255, 255, 255, 0.9);
    pointer-events: none;
    z-index: 9999;
    user-select: none;
  }

  .snowflake:nth-of-type(1) {
    left: 10%;
    top: -30px;
    animation: snowfall 12s linear infinite;
    animation-delay: 0s;
  }

  .snowflake:nth-of-type(2) {
    left: 20%;
    top: -30px;
    animation: snowfall 14s linear infinite;
    animation-delay: 2s;
  }

  .snowflake:nth-of-type(3) {
    left: 30%;
    top: -30px;
    animation: snowfall 10s linear infinite;
    animation-delay: 4s;
  }

  .snowflake:nth-of-type(4) {
    left: 40%;
    top: -30px;
    animation: snowfall 15s linear infinite;
    animation-delay: 1s;
  }

  .snowflake:nth-of-type(5) {
    left: 50%;
    top: -30px;
    animation: snowfall 11s linear infinite;
    animation-delay: 3s;
  }

  .snowflake:nth-of-type(6) {
    left: 60%;
    top: -30px;
    animation: snowfall 13s linear infinite;
    animation-delay: 5s;
  }

  .snowflake:nth-of-type(7) {
    left: 70%;
    top: -30px;
    animation: snowfall 12s linear infinite;
    animation-delay: 2.5s;
  }

  .snowflake:nth-of-type(8) {
    left: 80%;
    top: -30px;
    animation: snowfall 14s linear infinite;
    animation-delay: 4.5s;
  }

  .snowflake:nth-of-type(9) {
    left: 90%;
    top: -30px;
    animation: snowfall 10s linear infinite;
    animation-delay: 1.5s;
  }

  .snowflake:nth-of-type(10) {
    left: 15%;
    top: -30px;
    animation: snowfall 16s linear infinite;
    animation-delay: 3.5s;
  }

  /* Subtle Christmas accent for header */
  .christmas-accent {
    position: relative;
  }

  .christmas-accent .headerLogoWrapper {
    position: relative;
  }
  @media (min-width: 600px) {
    .christmas-accent .headerLogoWrapper::before {
      content: '🎄🎅';
      position: absolute;
      left: -60px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 24px;
      opacity: 0.8;
      filter: drop-shadow(0 0 5px rgba(255, 215, 0, 0.6));
      pointer-events: none;
    }
  }
`;
